export const SET_DEFAULT_COLLECTION = "SET_DEFAULT_COLLECTION";
export const CLEAR_DEFAULT_COLLECTION = "CLEAR_DEFAULT_COLLECTION";
